// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__Dyd0y","list":"PatternAutocomplete_list__wHbYs"};